import { FunctionButton } from '@pulse-web-ui/button-v2';
import { styled, typography } from '@pulse-web-ui/theme';

export const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HintButton = styled(FunctionButton)`
  ${typography.regular16};
  line-height: 20px;
  margin-bottom: 24px;
`;

export const StyledTitle = styled.h3`
  width: 100%;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 0;
`;

export const StyledDescription = styled.div`
  width: 100%;
  margin-top: 4px;
`;

export const StyledContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;
